import $ from 'jquery'

export const buildAdditionalValidationRulesAndMessages = (validationRules, errorMessages) => {
  $.each(window.formContext.validations.cmsValidationRules, (fieldName, rule) => {
    if ($('#' + fieldName).is(':hidden')) {
      return
    }

    if (!(fieldName in validationRules)) {
      validationRules[fieldName] = {}
    }
    validationRules[fieldName][fieldName] = true

    if (!(fieldName in errorMessages)) {
      errorMessages[fieldName] = {}
    }
    errorMessages[fieldName][fieldName] = rule.errorMessage
  })
}

export const addAdditionalRulesValidators = () => {
  $.each(window.formContext.validations.cmsValidationRules, (fieldName, rule) => {
    $.validator.addMethod(fieldName, function (value, element, param) {
      const regex = new RegExp(rule.regex)
      return regex.test(value)
    })
  })
}
